import {
  DEVICEID_LOADER_START,
  DEVICEID_LOADER_STOP,
  FETCH_DEVICES_SUCCESS,
  FETCH_DEVICES_FAILURE,
  UPDATE_DEVICE_STATUS_REQUEST,
  UPDATE_DEVICE_STATUS_SUCCESS,
  UPDATE_DEVICE_STATUS_FAILURE,
  COMM_CHECK_REQUEST,
  COMM_CHECK_SUCCESS,
  COMM_CHECK_FAILURE,
  LOADER_START,
  LOADER_STOP,
  COMMAND_SUCCESS,
  COMMAND_FAILURE,
  GET_DEVICE_BY_ID_REQUEST,
  GET_DEVICE_BY_ID_SUCCESS,
  GET_DEVICE_BY_ID_FAILURE,
  CLEAR_COMMAND_RESPONSE,
} from "./types";

const initialState = {
  isLoading: false,
  devices: [],
  error: null,
  commCheckResult: null,
  commCheckLoading: false,
  commandResponses: {},
  deviceData: null,
};

const deviceIdReducer = (state = initialState, action) => {
  switch (action.type) {
    case DEVICEID_LOADER_START:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case DEVICEID_LOADER_STOP:
      return {
        ...state,
        isLoading: false,
      };

    case LOADER_START:
      return {
        ...state,
        commCheckLoading: true,
        error: null,
      };

    case LOADER_STOP:
      return {
        ...state,
        commCheckLoading: false,
      };

    case FETCH_DEVICES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        devices: action.payload || [],
        error: null,
      };

    case FETCH_DEVICES_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.error,
      };

    case UPDATE_DEVICE_STATUS_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case UPDATE_DEVICE_STATUS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        devices: state.devices.map((device) =>
          device.deviceId === action.payload.deviceId
            ? { ...device, status: action.payload.status }
            : device
        ),
        error: null,
      };

    case UPDATE_DEVICE_STATUS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.error,
      };

    case COMM_CHECK_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
        commCheckResult: null,
      };

    case COMM_CHECK_SUCCESS:
      return {
        ...state,
        isLoading: false,
        commCheckResult: action.payload,
        error: null,
      };

    case COMM_CHECK_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.error,
        commCheckResult: null,
      };

    case COMMAND_SUCCESS:
      return {
        ...state,
        commandResponses: {
          ...state.commandResponses,
          [action.commandType]: action.payload,
        },
        error: null,
      };

    case COMMAND_FAILURE:
      return {
        ...state,
        error: action.error,
      };

    case GET_DEVICE_BY_ID_REQUEST:
      return {
        ...state,
        commCheckLoading: true,
        error: null,
        deviceData: null,
      };

    case GET_DEVICE_BY_ID_SUCCESS:
      return {
        ...state,
        commCheckLoading: false,
        deviceData: action.payload,
        error: null,
      };

    case GET_DEVICE_BY_ID_FAILURE:
      return {
        ...state,
        commCheckLoading: false,
        error: action.error,
        deviceData: null,
      };

    case CLEAR_COMMAND_RESPONSE:
      return {
        ...state,
        commandResponses: {
          ...state.commandResponses,
          [action.commandType]: null,
        },
      };

    case "@@deviceId/CLEAR_DEVICE_DATA":
      return {
        ...state,
        deviceData: null,
      };

    default:
      return state;
  }
};

export default deviceIdReducer;
